import React from 'react';

const ReferenceReport = ({ data }) => {
  const referenceData = data.reference;
  const listAllResponses = (responses) => {
    return (
      <div>
        {responses[0].map((response, index) => (
          <p key={index}>{response}</p>
        ))}
      </div>
    );
  };

  const renderTable = (header, values) => {
    return (
        <div className="overflow-x-auto">
          <table className="border-collapse border-b-2 mx-auto mb-6">
            <thead className='bg-gray-100'>
            <tr>
              {header.length === 1 ?
                <th className="border-b-2 px-4 py-2 text-center text-sm">{header[0]} </th>
                : header.map((item, index) => (
                  <th key={index} className="border-b-2 px-4 py-2 text-sm">{item}</th>
                ))}
            </tr>
            </thead>
            <tbody>
            {values.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {row.map((cell, cellIndex) => (
                  <td key={cellIndex} className="border-b-2 px-4 py-2 text-sm">
                    {cell.split('\n').map((line, index) => (
                      <React.Fragment key={index}>
                        {line}
                        <br />
                      </React.Fragment>
                    ))}
                  </td>
                ))}
              </tr>
            ))}
            </tbody>
          </table>
        </div>
    )
  }

  const renderReferences = () => {
    return (
      <div className='text-sm'>
        {referenceData.source && referenceData.source.split('\n').map((line, index) => (
          <p key={index}
             className="py-1 text-sm">{line}
          </p>
        ))}
        <p
          className='pt-1'>{referenceData.references !== null ?
          <span>
              <span className='font-semibold'>Fonte: </span>
            {referenceData.references}
            </span> : ""}
        </p>
      </div>
    )
  }

  return (
    <div className='bg-white shadow-md w-full pb-4 mt-6 my-6 border-2 opacity-75'>
      <div className='text-center px-4 md:px-24 2xl:px-60 font-semibold py-4 bg-gray-50'>
        <h1 className='text-base select-none primary'>Relatório de Referências</h1>
        <p className='text-sm'>{referenceData.title}</p>
      </div>
      <hr/>
      <div className='text-base font-normal text-justify px-10 py-6'>
        {referenceData.description.split('\n').map((line, index) => (
          <p key={index} className="py-1 text-sm">{line}
          </p>
        ))}
      </div>
      {!((referenceData.header && referenceData.header.length > 0 && referenceData.header[0].toLowerCase().substring(0, 5) === "refer") ||
          (referenceData.secondaryHeader && referenceData.secondaryHeader.length > 0 && referenceData.secondaryHeader[0].toLowerCase().substring(0, 5) === "refer")) &&
        (referenceData.values && referenceData.values.length > 0) &&
        (
          <div className='text-center px-4 md:px-24 2xl:px-60 font-semibold py-3 mb-4 bg-gray-50 border border-x-2'>
            <h1 className='text-base select-none'>Referências</h1>
          </div>
        )
      }
      {(referenceData.values && referenceData.values.length > 0) &&
        <div className='text-base font-normal text-justify px-10'>
          {Array.isArray(referenceData.values) ? renderTable(referenceData.header, referenceData.values) : (referenceData.values && listAllResponses(referenceData.values))}
          {referenceData.secondaryHeader && referenceData.secondaryValues && referenceData.secondaryValues.length !== 0 && (
            renderTable(referenceData.secondaryHeader, referenceData.secondaryValues)
          )}
        </div>
      }
      {!referenceData.reference &&
        (
          <div className='text-center px-4 md:px-24 2xl:px-60 font-semibold py-4 mb-2 bg-gray-50 border border-x-2'>
            <h1 className='text-base select-none'>Referências
              Bibliográficas</h1>
          </div>
        )}
      <div className='text-base font-normal text-justify px-10 pb-4'>
        {renderReferences()}
      </div>
      <hr/>
    </div>
  );
};

export default ReferenceReport;
